import React from 'react';
import PropTypes from 'prop-types';
import {
  Text, View, TouchableOpacity,
} from 'react-native';
import md5 from 'md5';
import ScrollFading from '../effects/ScrollFading';
import styles from '../../styles';
import { ViewPropTypes } from 'deprecated-react-native-prop-types'

import ItemExpanded from '../../assets/images/item_expanded.svg';
import ItemCollapsed from '../../assets/images/item_collapsed.svg';

class ExpandableList extends React.Component {
  constructor(props, context) {
    super(props, context);

    const { items } = this.props;

    this.state = {
      items,
    };
  }

  render() {
    const { style, itemBackground } = this.props;
    const { items } = this.state;

    return (
      <ScrollFading style={style}>
        {items.map((item, index) => (
          <TouchableOpacity
            key={md5(index.toString())}
            style={{
              borderRadius: 20,
              padding: 20,
              width: '80%',
              maxWidth: 600,
              alignSelf: 'center',
              marginBottom: 10,
              flexDirection: 'row',
              backgroundColor: itemBackground,
            }}
            onPress={
              () => {
                items[index].expanded = !item.expanded;
                this.setState({ items });
              }
            }
          >
            <View
              style={{
                flex: 1,
                flexDirection: 'column',
              }}
            >
              <Text
                style={{
                  fontFamily: styles.primaryFont500,
                  fontWeight: '500',
                  fontSize: 16,
                  lineHeight: 20,
                  paddingVertical: 6,
                  color: '#26272A',
                }}
              >
                {item.text}
              </Text>

              {item.expanded && (
                <Text
                  style={{
                    fontFamily: styles.primaryFont300,
                    fontWeight: '300',
                    fontSize: 14,
                    lineHeight: 18,
                    paddingVertical: 6,
                    color: '#4E4B66',
                  }}
                >
                  {item.description}
                </Text>
              )}
            </View>
            <View
              style={{
                paddingTop: 12,
                width: 20,
              }}
            >
              {item.expanded ? (
                <ItemExpanded key="expanded" />
              ) : (
                <ItemCollapsed key="collapsed" />
              )}
            </View>
          </TouchableOpacity>
        ))}
      </ScrollFading>
    );
  }
}

ExpandableList.defaultProps = {
  style: {},
  itemBackground: styles.primaryColorWithOpacity,
};

ExpandableList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  })).isRequired,
  style: ViewPropTypes.style,
  itemBackground: PropTypes.string,
};

export default ExpandableList;
